import { BannerGridData } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import ContentTile from "./ContentTile";
import MediaTile from "./MediaTile";
import { hasArrayElements } from "@/apiUtils/commonUtils";

interface IProps {
  content: BannerGridData;
  isPDP?: boolean;
  translations?: any; // Add translations prop
}

const BannerGrid = ({ content, isPDP, translations }: IProps) => {
  return (
    <div className="container md:px-12">
      {content?.items?.map((item, index) => (
        <div className="flex flex-wrap" key={item?.key}>
          <div className={cn("w-full md:w-1/2", index % 2 === 0 ? "md:order-1" : "md:order-2")}>
            <MediaTile
              content={item?.mediaTile}
              bannerType={item?.bannerType}
              link={item?.contentTile?.link}
              title={item?.contentTile?.title}
              isGridImages={item?.contentTile?.images && hasArrayElements(item?.contentTile?.images)}
              isPDP={isPDP}
            />
          </div>
          <div
            className={cn(
              "w-full bg-tertiary-5 md:w-1/2",
              index % 2 === 0 ? "md:order-2" : "md:order-1",
            )}
          >
            <ContentTile content={item?.contentTile} translations={translations} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BannerGrid;
